'use strict';

var ChartClassUsageDirective = function ChartClassUsageDirective(Chart, chartFormatter) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/chart-class-usage.html'),
    controller: 'ChartClassUsageController',
    scope: {
      legend: '=',
      chartModel: '=',
      sizingParams: '=',
      selectionHandler: '='
    },
    link: function link($scope, element) {
      var chartFormatters = {
        xAxisTickFormatter: chartFormatter.identity,
        yAxisTickFormatter: chartFormatter.humanReadable,
        tooltipFormatter: $scope.createTooltipFormatter()
      };
      var chartElement = element.find('.chart-container');
      var chart = new Chart(chartElement, chartFormatters, $scope.legend, $scope.chartModel);
      $scope.renderChartDataPresent = function () {
        chart.render($scope.chartModel, $scope.sizingParams);
      };
      chart.on('rangechange', function (ranges, clearBrushes) {
        $scope.rangeChangeHandler(ranges, clearBrushes);
      });
      $scope.clearBrushSelection = function (evt, sourceCabinCode) {
        if ($scope.chartModel.cabinCode !== sourceCabinCode) {
          chart.clearBrushSelection();
        }
      };
      $scope.resetBrushSelection = function () {
        chart.resetBrushSelection($scope.chartModel);
      };
      $scope.$on('chart-class-usage:resetBrushSelection', $scope.resetBrushSelection);
      $scope.$on('chart-class-usage:clearBrushSelection', $scope.clearBrushSelection);
      element.on('contextmenu', function () {
        //prevent default context menu
        return false;
      });
    }
  };
};
ChartClassUsageDirective.$inject = ['ChartClassUsage', 'FormatterService'];
module.exports = ChartClassUsageDirective;